import { findNearestExchangeRate } from './currency.js';

export function getTrialData(context, fromts, tots, selectedcurrency, basis, basecurrency) { //20240108
    const {
        journalentries,
        transactions,
        salesinvoices,
        purchaseinvoices,
        payslips,
        interaccounttransfers,
        assetaccounts,
        liabilityaccounts,
        equityaccounts,
        cashaccounts,
        incomeaccounts,
        expenseaccounts,
        clients,
        suppliers,
        items,
        staff,
        exchangerates,
        currencies
    } = context;

    const data = {
        equity: [],
        assets: [],
        liabilities: [],
        cash: [],
        items: [],
        suppliers: [],
        staff: [],
        expenses: [],
        income: []
    };

    let accountCurrency = selectedcurrency ? selectedcurrency : basecurrency;
    let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;

    equityaccounts
        .sort((a, b) => a.orderid - b.orderid)
        .forEach((account) => {
            let accountCurrency = selectedcurrency ? selectedcurrency : account.currencyid;
            let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;
            let debit = 0;
            let credit = 0;

            journalentries
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((entry) => {
                    entry.rows.forEach((row) => {
                        if (row.accountid === account.id) {
                            if (entry.currencyid === accountCurrency) {
                                debit += parseFloat(row.debit);
                                credit += parseFloat(row.credit);
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedDebit = parseFloat(row.debit) * exchangerate;
                                const convertedCredit = parseFloat(row.credit) * exchangerate;
                                debit += convertedDebit;
                                credit += convertedCredit;
                            }
                        }
                    });
                });
            data.equity.push({
                id: account.id,
                orderid: account.orderid,
                name: account.name,
                accounttype: 'equity',
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: debit,
                credit: credit,
                balance: debit - credit
            });
        });

    assetaccounts
        .sort((a, b) => a.orderid - b.orderid)
        .forEach((account) => {
            let accountCurrency = selectedcurrency ? selectedcurrency : account.currencyid;
            let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;
            let debit = 0;
            let credit = 0;

            salesinvoices
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((invoice) => {
                    let assetaccountid = clients.find(cl => cl.id == invoice.clientid)?.assetaccountid
                    let amount = parseFloat(invoice.amount)
                    if (assetaccountid) {
                        if (assetaccountid === account.id) {
                            if (invoice.currencyid === accountCurrency) {
                                debit += amount
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                debit += amount * exchangerate;
                            }
                        }
                    }
                });

            transactions
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((transaction) => {
                    let assetaccountid = clients.find(cl => cl.id == transaction.from)?.assetaccountid;
                    if (assetaccountid == account.id) {
                        if (accountCurrency === transaction.currencyid) {
                            credit += parseFloat(transaction.amount);
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, accountCurrency);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            credit += parseFloat(transaction.amount) * exchangerate;
                        }
                    }
                    if (transaction.to === account.id) {
                        if (accountCurrency === transaction.currencyid) {
                            debit += parseFloat(transaction.amount);
                        } else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, accountCurrency);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            debit += parseFloat(transaction.amount) * exchangerate;
                        }
                    }
                });

            journalentries
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((entry) => {
                    entry.rows.forEach((row) => {
                        if (row.accounttype == 'client') {
                            let assetaccountid = clients.find(cl => cl.id == row.accountid)?.assetaccountid;
                            if (assetaccountid == account.id) {
                                if (entry.currencyid === accountCurrency) {
                                    debit += parseFloat(row.debit);
                                    credit += parseFloat(row.credit);
                                }
                                else {
                                    const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                    const exchangerate = NearestExchangeRate.exchangerate;
                                    const convertedDebit = parseFloat(row.debit) * exchangerate;
                                    const convertedCredit = parseFloat(row.credit) * exchangerate;
                                    debit += parseFloat(convertedDebit);
                                    credit += parseFloat(convertedCredit);
                                }
                            }
                        }
                        if (row.accountid === account.id) {
                            if (entry.currencyid === accountCurrency) {
                                debit += parseFloat(row.debit);
                                credit += parseFloat(row.credit);
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedDebit = parseFloat(row.debit) * exchangerate;
                                const convertedCredit = parseFloat(row.credit) * exchangerate;
                                debit += parseFloat(convertedDebit);
                                credit += parseFloat(convertedCredit);
                            }
                        }
                    });
                });
            data.assets.push({
                id: account.id,
                orderid: account.orderid,
                name: account.name,
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: debit,
                credit: credit,
                balance: debit - credit
            });
        });

    liabilityaccounts
        .sort((a, b) => a.orderid - b.orderid)
        .forEach((account) => {
            let accountCurrency = selectedcurrency ? selectedcurrency : account.currencyid;
            let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;
            let debit = 0;
            let credit = 0;

            purchaseinvoices
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((invoice) => {
                    let liabilityaccountid = suppliers.find(supp => supp.id == invoice.supplierid)?.liabilityaccountid
                    if (liabilityaccountid) {
                        if (liabilityaccountid === account.id) {
                            let amount = parseFloat(invoice.amount)
                            if (invoice.currencyid === accountCurrency) {
                                credit += amount
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                credit += amount * exchangerate;
                            }
                        }
                    }
                });

            payslips
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((payslip) => {
                    if (payslip.liabilityaccountid === account.id) {
                        if (payslip.currencyid === accountCurrency) {
                            credit += parseFloat(payslip.amount);
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, payslip.ts, payslip.currencyid, accountCurrency);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            credit += parseFloat(payslip.amount) * exchangerate;
                        }
                    }
                });

            transactions
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((transaction) => {
                    if (transaction.totype === 'liability') {
                        if (transaction.beneficiarytype == 'supplier') {
                            let liabilityaccountid = suppliers.find(sup => sup.id == transaction.beneficiaryid)?.liabilityaccountid;
                            if (liabilityaccountid == account.id) {
                                if (accountCurrency === transaction.currencyid) {
                                    debit += parseFloat(transaction.amount);
                                }
                                else {
                                    const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, accountCurrency);
                                    const exchangerate = NearestExchangeRate.exchangerate;
                                    debit += parseFloat(transaction.amount) * exchangerate;
                                }
                            }
                        }
                        else {
                            if (transaction.to === account.id) {
                                if (accountCurrency === transaction.currencyid) {
                                    debit += parseFloat(transaction.amount);
                                }
                                else {
                                    const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, accountCurrency);
                                    const exchangerate = NearestExchangeRate.exchangerate;
                                    debit += parseFloat(transaction.amount) * exchangerate;
                                }
                            }
                        }
                    }
                });

            journalentries
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((entry) => {
                    entry.rows.forEach((row) => {
                        if (row.accounttype == 'staff') {
                            let liabilityaccountid = staff.find(st => st.id == row.accountid)?.liabilityaccountid;
                            if (liabilityaccountid) {
                                if (liabilityaccountid === account.id) {
                                    if (entry.currencyid === accountCurrency) {
                                        debit += parseFloat(row.debit);
                                        credit += parseFloat(row.credit);
                                    }
                                    else {
                                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                        const exchangerate = NearestExchangeRate.exchangerate;
                                        const convertedDebit = parseFloat(row.debit) * exchangerate;
                                        const convertedCredit = parseFloat(row.credit) * exchangerate;
                                        debit += parseFloat(convertedDebit);
                                        credit += parseFloat(convertedCredit);
                                    }
                                }
                            }
                        }
                        if (row.accounttype == 'supplier') {
                            let liabilityaccountid = suppliers.find(sup => sup.id == row.accountid)?.liabilityaccountid;
                            if (liabilityaccountid) {
                                if (liabilityaccountid === account.id) {
                                    if (entry.currencyid === accountCurrency) {
                                        debit += parseFloat(row.debit);
                                        credit += parseFloat(row.credit);
                                    }
                                    else {
                                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                        const exchangerate = NearestExchangeRate.exchangerate;
                                        const convertedDebit = parseFloat(row.debit) * exchangerate;
                                        const convertedCredit = parseFloat(row.credit) * exchangerate;
                                        debit += parseFloat(convertedDebit);
                                        credit += parseFloat(convertedCredit);
                                    }
                                }
                            }
                        }
                        else if (row.accountid === account.id) {
                            if (entry.currencyid === accountCurrency) {
                                debit += parseFloat(row.debit);
                                credit += parseFloat(row.credit);
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedDebit = parseFloat(row.debit) * exchangerate;
                                const convertedCredit = parseFloat(row.credit) * exchangerate;
                                debit += parseFloat(convertedDebit);
                                credit += parseFloat(convertedCredit);
                            }
                        }
                    });
                });

            salesinvoices
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((invoice) => {
                    invoice.items.forEach((item) => {
                        if (item.accountid === account.id) {
                            const totalPrice = parseFloat(item.itemprice) * parseFloat(item.itemquantity);
                            if (invoice.currencyid === accountCurrency) {
                                credit += totalPrice
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedCredit = totalPrice * exchangerate;
                                credit += convertedCredit;
                            }
                        }
                    });
                });

            data.liabilities.push({
                id: account.id,
                orderid: account.orderid,
                name: account.name,
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: debit,
                credit: credit,
                balance: debit - credit
            });
        });

    items
        .filter(item => item.type === 'inventory')
        .forEach((item) => {
            let accountCurrency = selectedcurrency ? selectedcurrency : basecurrency;
            let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;
            let debit = 0;
            let credit = 0;
            let quantitypurchased = 0;
            let quantitysold = 0;
            let totalcostpurchased = 0;

            purchaseinvoices
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((purchaseinvoice) => {
                    purchaseinvoice.items.forEach((purchaseinvoiceitem) => {
                        if (purchaseinvoiceitem.accountid === item.id) {
                            const qty = parseFloat(purchaseinvoiceitem.itemquantity);
                            const unitcost = parseFloat(purchaseinvoiceitem.itemcost);
                            const totalCost = qty * unitcost;

                            quantitypurchased += qty;

                            if (purchaseinvoice.currencyid === accountCurrency) {
                                debit += totalCost;
                                totalcostpurchased += totalCost;
                            } else {
                                const NearestExchangeRate = findNearestExchangeRate(
                                    exchangerates,
                                    purchaseinvoice.ts,
                                    purchaseinvoice.currencyid,
                                    accountCurrency
                                );
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedCost = totalCost * exchangerate;

                                debit += convertedCost;
                                totalcostpurchased += convertedCost;
                            }
                        }
                    });
                });
            let avgcost = quantitypurchased > 0 ? totalcostpurchased / quantitypurchased : 0;

            let totalquantitysold = 0;
            salesinvoices
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((salesinvoice) => {
                    salesinvoice.items.forEach((salesinvoiceitem) => {
                        if (salesinvoiceitem.accountid === item.id) {
                            const qty = parseFloat(salesinvoiceitem.itemquantity);
                            totalquantitysold += qty;
                        }
                    });
                });
            credit = totalquantitysold * avgcost

            data.items.push({
                id: item.id,
                orderid: item.orderid,
                name: item.name,
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: debit,
                credit: credit,
                balance: debit - credit,
                quantitypurchased,
                quantitysold,
                avgcost
            });
        });

    cashaccounts.forEach((account) => {
        const currencySymbol = currencies.find((currency) => currency.id === account.currencyid)?.symbol;

        let openingbalance = parseFloat(account.openingbalance) || 0;
        let debit = openingbalance > 0 ? openingbalance : 0;
        let credit = openingbalance < 0 ? -openingbalance : 0;

        transactions
            .filter(tx => tx.ts >= fromts && tx.ts <= tots)
            .forEach((transaction) => {
                if (transaction.to === account.id) {
                    if (transaction.currencyid === account.currencyid) {
                        debit += parseFloat(transaction.amount);
                    }
                    else {
                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, account.currencyid);
                        const exchangerate = NearestExchangeRate.exchangerate;
                        debit += parseFloat(transaction.amount) * exchangerate;
                    }
                }
                if (transaction.from === account.id) {
                    if (transaction.currencyid === account.currencyid) {
                        credit += parseFloat(transaction.amount);
                    }
                    else {
                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, account.currencyid);
                        const exchangerate = NearestExchangeRate.exchangerate;
                        credit += parseFloat(transaction.amount) * exchangerate;
                    }
                }
            });

        interaccounttransfers
            .filter(tx => tx.ts >= fromts && tx.ts <= tots)
            .forEach((transfer) => {
                if (transfer.to === account.id) {
                    if (transfer.tocurrencyid === account.currencyid) {
                        debit += parseFloat(transfer.toamount);
                    }
                    else {
                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, transfer.ts, transfer.tocurrencyid, account.currencyid);
                        const exchangerate = NearestExchangeRate.exchangerate;
                        debit += parseFloat(transfer.toamount) * exchangerate;
                    }
                }
                if (transfer.from === account.id) {
                    if (transfer.fromcurrencyid === account.currencyid) {
                        credit += parseFloat(transfer.fromamount);
                    }
                    else {
                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, transfer.ts, transfer.fromcurrencyid, account.currencyid);
                        const exchangerate = NearestExchangeRate.exchangerate;
                        credit += parseFloat(transfer.fromamount) * exchangerate;
                    }
                }
            });

        journalentries
            .filter(tx => tx.ts >= fromts && tx.ts <= tots)
            .forEach((entry) => {
                entry.rows.forEach((row) => {
                    if (row.accountid === account.id) {
                        if (entry.currencyid === account.currencyid) {
                            debit += parseFloat(row.debit);
                            credit += parseFloat(row.credit);
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, account.currencyid);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            debit += parseFloat(row.debit) * exchangerate;
                            credit += parseFloat(row.credit) * exchangerate;
                        }
                    }
                });
            });

        data.cash.push({
            id: account.id,
            orderid: account.orderid,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencySymbol,
            debit: debit,
            credit: credit,
            balance: debit - credit,
        });
    });

    staff
        .sort((a, b) => a.orderid - b.orderid)
        .forEach((st) => {
            let accountCurrency = selectedcurrency ? selectedcurrency : basecurrency;
            let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;
            let debit = 0;
            let credit = 0;

            payslips
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((payslip) => {
                    if (payslip.staffid === st.id) {
                        if (accountCurrency === payslip.currencyid) {
                            credit += parseFloat(payslip.amount);
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, payslip.ts, payslip.currencyid, accountCurrency);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            credit += parseFloat(payslip.amount) * exchangerate;
                        }
                    }
                });

            journalentries
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((entry) => {
                    entry.rows.forEach((row) => {
                        if (row.accountid === st.id) {
                            if (accountCurrency === accountCurrency) {
                                debit += parseFloat(row.debit);
                                credit += parseFloat(row.credit);
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                debit += parseFloat(row.debit) * exchangerate;
                                credit += parseFloat(row.credit) * exchangerate;
                            }
                        }
                    });
                });

            transactions
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((transaction) => {
                    if (transaction.beneficiaryid === st.id) {
                        if (accountCurrency === transaction.currencyid) {
                            debit += parseFloat(transaction.amount);
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, accountCurrency);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            debit += parseFloat(transaction.amount) * exchangerate;
                        }
                    }
                });

            data.staff.push({
                id: st.id,
                name: st.name,
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: debit,
                credit: credit,
                balance: debit - credit
            });
        });

    expenseaccounts
        .sort((a, b) => a.orderid - b.orderid)
        .forEach(account => {
            let accountCurrency = selectedcurrency ? selectedcurrency : account.currencyid;
            let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;
            let debit = 0;
            let credit = 0;

            purchaseinvoices
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((invoice) => {
                    invoice.items.forEach((item) => {
                        if (item.accountid === account.id) {
                            const totalCost = parseFloat(item.itemcost) * parseFloat(item.itemquantity);
                            if (invoice.currencyid === accountCurrency) {
                                debit += totalCost
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedCredit = totalCost * exchangerate;
                                debit += convertedCredit;
                            }
                        }
                    });
                });

            transactions
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((transaction) => {
                    if (transaction.to === account.id) {
                        if (accountCurrency === transaction.currencyid) {
                            debit += parseFloat(transaction.amount);
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, accountCurrency);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            debit += parseFloat(transaction.amount) * exchangerate;
                        }
                    }
                });

            journalentries
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((entry) => {
                    entry.rows.forEach((row) => {
                        if (row.accountid === account.id) {
                            if (entry.currencyid === accountCurrency) {
                                debit += parseFloat(row.debit);
                                credit += parseFloat(row.credit);
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                debit += parseFloat(row.debit) * exchangerate;
                                credit += parseFloat(row.credit) * exchangerate;
                            }
                        }
                    });
                });

            payslips
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((payslip) => {
                    payslip.earnings.forEach((row) => {
                        if (row.accountid === account.id) {
                            if (payslip.currencyid === accountCurrency) {
                                debit += parseFloat(row.amount);
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, payslip.ts, payslip.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                debit += parseFloat(row.amount) * exchangerate;
                            }
                        }
                    });
                });

            data.expenses.push({
                id: account.id,
                orderid: account.orderid,
                name: account.name,
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: debit,
                credit: credit,
                balance: debit - credit
            });
        })


    incomeaccounts
        .sort((a, b) => a.orderid - b.orderid)
        .forEach(account => {
            let accountCurrency = selectedcurrency ? selectedcurrency : basecurrency;
            let accountCurrencySymbol = currencies.find((currency) => currency.id === accountCurrency)?.symbol;
            let debit = 0;
            let credit = 0;

            journalentries
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((entry) => {
                    entry.rows.forEach((row) => {
                        if (row.accountid === account.id) {
                            const convertedDebit = parseFloat(row.debit);
                            const convertedCredit = parseFloat(row.credit);
                            if (entry.currencyid === accountCurrency) {
                                debit += convertedDebit;
                                credit += convertedCredit;
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                debit += convertedDebit * exchangerate;
                                credit += convertedCredit * exchangerate;
                            }
                        }
                    });
                });

            salesinvoices
                .filter(tx => tx.ts >= fromts && tx.ts <= tots)
                .forEach((invoice) => {
                    invoice.items.forEach((item) => {
                        if (item.accountid === account.id) {
                            const totalPrice = parseFloat(item.itemprice) * parseFloat(item.itemquantity);
                            if (invoice.currencyid === accountCurrency) {
                                credit += totalPrice
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, accountCurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                const convertedCredit = totalPrice * exchangerate;
                                credit += convertedCredit;
                            }
                        }
                    });
                });

            data.income.push({
                id: account.id,
                orderid: account.orderid,
                name: account.name,
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: debit,
                credit: credit,
                balance: debit - credit
            });
        })

    if (basis === 'accrual') {
        let inventorycostdebit = 0;
        let inventorycostcredit = 0;
        purchaseinvoices
            .filter(tx => tx.ts >= fromts && tx.ts <= tots)
            .forEach((invoice) => {
                invoice.items.forEach((item) => {
                    if (item.accounttype === 'item') {
                        const totalCost = parseFloat(item.itemcost) * parseFloat(item.itemquantity);
                        if (invoice.currencyid === accountCurrency) {
                            inventorycostdebit += totalCost
                        }
                        else {
                            const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, accountCurrency);
                            const exchangerate = NearestExchangeRate.exchangerate;
                            inventorycostdebit += totalCost * exchangerate;
                        }
                    }
                });
            });
        if (inventorycostdebit != 0) {
            data.expenses.push({
                id: '',
                orderid: '',
                name: 'Inventory - cost',
                currencyid: accountCurrency,
                currencysymbol: accountCurrencySymbol,
                debit: inventorycostdebit,
                credit: inventorycostcredit,
                balance: inventorycostdebit - inventorycostcredit
            });
        }
    }

    let inventorysalesdebit = 0;
    let inventorysalescredit = 0;
    salesinvoices
        .filter(tx => tx.ts >= fromts && tx.ts <= tots)
        .forEach((invoice) => {
            invoice.items.forEach((item) => {
                if (item.accounttype === 'item') {
                    const totalPrice = parseFloat(item.itemprice) * parseFloat(item.itemquantity);
                    if (invoice.currencyid === accountCurrency) {
                        inventorysalescredit += totalPrice
                    }
                    else {
                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, invoice.ts, invoice.currencyid, accountCurrency);
                        const exchangerate = NearestExchangeRate.exchangerate;
                        const convertedCredit = totalPrice * exchangerate;
                        inventorysalescredit += convertedCredit;
                    }
                }
            });
        });
    if (inventorysalescredit != 0) {
        data.income.push({
            id: '',
            orderid: '',
            name: 'Inventory - sales',
            currencyid: accountCurrency,
            currencysymbol: accountCurrencySymbol,
            debit: inventorysalesdebit,
            credit: inventorysalescredit,
            balance: inventorysalesdebit - inventorysalescredit
        });
    }

    let openingbalanceequitydebit = 0;
    let openingbalanceequitycredit = 0;
    cashaccounts.forEach((account) => {
        let openingbalance = parseFloat(account.openingbalance) || 0;

        if (account.currencyid === accountCurrency) {
            if (openingbalance > 0) openingbalanceequitycredit += openingbalance
            if (openingbalance < 0) openingbalanceequitydebit += openingbalance
        } else {
            const NearestExchangeRate = findNearestExchangeRate(exchangerates, fromts, account.currencyid, accountCurrency);
            const exchangerate = NearestExchangeRate.exchangerate || 1;
            const convertedBalance = openingbalance * exchangerate;

            if (openingbalance > 0) openingbalanceequitycredit += convertedBalance
            if (openingbalance < 0) openingbalanceequitydebit += convertedBalance
        }
    });

    const netBalance = openingbalanceequitydebit - openingbalanceequitycredit;
    if (netBalance !== 0) {
        data.equity.push({
            id: '',
            orderid: '',
            name: 'Opening balance cash equity',
            currencyid: accountCurrency,
            currencysymbol: accountCurrencySymbol,
            debit: openingbalanceequitydebit,
            credit: openingbalanceequitycredit,
            balance: netBalance
        });
    }

    console.log(data)
    return data;
}

export function getTrialbalance(context, fromts, tots, coa, selectedcurrency, basis, basecurrency) {
    if (!coa) return [];

    const trial = [];
    let data = getTrialData(context, fromts, tots, selectedcurrency, basis, basecurrency)
    let accountCurrency = selectedcurrency ? selectedcurrency : basecurrency
    let accountCurrencySymbol = context.currencies.find((currency) => currency.id === accountCurrency)?.symbol;

    let totaldebit = 0;
    let totalcredit = 0;
    let totalbalance = 0;
    let suspense = 0;

    switch (coa) {
        case 'lebanon':
            trial.push({
                orderid: 1,
                name: 'Class 1 - Capital & Equity',
                type: 'group',
            });
            let debitclass1 = 0;
            let creditclass1 = 0;
            let balanceclass1 = 0;
            data.equity.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: account.accounttype,
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitclass1 += account.debit;
                    creditclass1 += account.credit;
                    balanceclass1 += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitclass1 += account.debit * exchangerate;
                    creditclass1 += account.credit * exchangerate;;
                    balanceclass1 += account.balance * exchangerate;;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Capital & Equity',
                currencysymbol: accountCurrencySymbol,
                debit: debitclass1,
                credit: creditclass1,
                balance: balanceclass1,
                type: 'total',
            });
            totaldebit += debitclass1;
            totalcredit += creditclass1;
            totalbalance += balanceclass1;

            trial.push({
                orderid: 2,
                name: 'Class 2 - Fixed Assets',
                type: 'group',
            });
            let debitclass2 = 0;
            let creditclass2 = 0;
            let balanceclass2 = 0;
            data.assets.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'asset',
                    type: 'item',
                });
                debitclass2 += account.debit
                creditclass2 += account.credit;
                balanceclass2 += account.balance;
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Assets',
                currencysymbol: accountCurrencySymbol,
                debit: debitclass2,
                credit: creditclass2,
                balance: balanceclass2,
                type: 'total',
            });
            totaldebit += debitclass2;
            totalcredit += creditclass2;
            totalbalance += balanceclass2;

            trial.push({
                orderid: 3,
                name: 'Class 3 - Inventory & Stock',
                type: 'group',
            });
            let debitclass3 = 0;
            let creditclass3 = 0;
            let balanceclass3 = 0;
            data.items.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'item',
                    type: 'item',
                });
                debitclass3 += account.debit;
                creditclass3 += account.credit;
                balanceclass3 += account.balance;
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Inventory & Stock',
                currencysymbol: accountCurrencySymbol,
                debit: debitclass3,
                credit: creditclass3,
                balance: balanceclass3,
                type: 'total',
            });
            totaldebit += debitclass3;
            totalcredit += creditclass3;
            totalbalance += balanceclass3;

            trial.push({
                orderid: 4,
                name: 'Class 4 - Third-Party Accounts (Clients, Suppliers)',
                type: 'group',
            });
            let debitclass4 = 0;
            let creditclass4 = 0;
            let balanceclass4 = 0;
            data.liabilities.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'liability',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitclass4 += account.debit;
                    creditclass4 += account.credit;
                    balanceclass4 += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitclass4 += account.debit * exchangerate;
                    creditclass4 += account.credit * exchangerate;
                    balanceclass4 += account.balance * exchangerate;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Third Party Accounts',
                currencysymbol: accountCurrencySymbol,
                debit: debitclass4,
                credit: creditclass4,
                balance: balanceclass4,
                type: 'total',
            });
            totaldebit += debitclass4;
            totalcredit += creditclass4;
            totalbalance += balanceclass4;

            trial.push({
                orderid: 5,
                name: 'Class 5 - Financial Accounts',
                type: 'group',
            });
            let debitclass5 = 0;
            let creditclass5 = 0;
            let balanceclass5 = 0;
            data.cash.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'cash',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitclass5 += account.debit;
                    creditclass5 += account.credit;
                    balanceclass5 += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitclass5 += account.debit * exchangerate;
                    creditclass5 += account.credit * exchangerate;
                    balanceclass5 += account.balance * exchangerate;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Financial Accounts',
                currencysymbol: accountCurrencySymbol,
                debit: debitclass5,
                credit: creditclass5,
                balance: balanceclass5,
                type: 'total',
            });
            totaldebit += debitclass5;
            totalcredit += creditclass5;
            totalbalance += balanceclass5;

            trial.push({
                orderid: 6,
                name: 'Class 6 - Expenses',
                type: 'group',
            });
            let debitclass6 = 0;
            let creditclass6 = 0;
            let balanceclass6 = 0;
            data.expenses.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'expense',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitclass6 += account.debit;
                    creditclass6 += account.credit;
                    balanceclass6 += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitclass6 += account.debit * exchangerate;
                    creditclass6 += account.credit * exchangerate;
                    balanceclass6 += account.balance * exchangerate;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Expenses',
                currencysymbol: accountCurrencySymbol,
                debit: debitclass6,
                credit: creditclass6,
                balance: balanceclass6,
                type: 'total',
            });
            totaldebit += debitclass6;
            totalcredit += creditclass6;
            totalbalance += balanceclass6;

            trial.push({
                orderid: 7,
                name: 'Class 7 - Income',
                type: 'group',
            });
            let debitclass7 = 0;
            let creditclass7 = 0;
            let balanceclass7 = 0;
            data.income.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'income',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitclass7 += account.debit;
                    creditclass7 += account.credit;
                    balanceclass7 += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitclass7 += account.debit * exchangerate;
                    creditclass7 += account.credit * exchangerate;
                    balanceclass7 += account.balance * exchangerate;
                }
            });

            trial.push({
                id: '',
                orderid: '',
                name: 'Total Income',
                currencysymbol: accountCurrencySymbol,
                debit: debitclass7,
                credit: creditclass7,
                balance: balanceclass7,
                type: 'total',
            });
            totaldebit += debitclass7;
            totalcredit += creditclass7;
            totalbalance += balanceclass7;

            suspense = totalcredit - totaldebit;
            if (Math.abs(suspense) > 0.001) {
                trial.push({
                    orderid: '',
                    name: 'Suspense',
                    type: 'group',
                });
                trial.push({
                    id: '',
                    orderid: '',
                    name: 'Suspense account found: some entries are missing or unbalanced. Please fix them before submitting the report.',
                    currencysymbol: accountCurrencySymbol,
                    debit: suspense > 0 ? suspense : 0,
                    credit: suspense < 0 ? Math.abs(suspense) : 0,
                    balance: 0,
                    accounttype: 'asset',
                    type: 'item',
                });
            }
            totaldebit += suspense > 0 ? suspense : 0;
            totalcredit += suspense < 0 ? Math.abs(suspense) : 0;

            trial.push({
                id: '',
                orderid: '',
                name: 'Total',
                currencysymbol: accountCurrencySymbol,
                debit: totaldebit,
                credit: totalcredit,
                balance: totalbalance,
                type: 'item',
            });
            break;

        case 'standard':
            trial.push({
                orderid: 1000,
                name: 'Assets',
                type: 'group',
            });
            let debitcash = 0;
            let creditcash = 0;
            let balancecash = 0;

            const allassets = [
                ...data.assets,
                ...data.cash,
            ];

            allassets.sort((a, b) => a.orderid - b.orderid);
            allassets.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'cash',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitcash += account.debit;
                    creditcash += account.credit;
                    balancecash += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitcash += account.debit * exchangerate;
                    creditcash += account.credit * exchangerate;
                    balancecash += account.balance * exchangerate;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Assets',
                currencysymbol: accountCurrencySymbol,
                debit: debitcash,
                credit: creditcash,
                balance: balancecash,
                accounttype: 'asset',
                type: 'item',
            });
            totaldebit += debitcash;
            totalcredit += creditcash;
            totalbalance += balancecash;

            trial.push({
                orderid: 2000,
                name: 'Accounts Payable',
                type: 'group',
            });
            let debitpayables = 0;
            let creditpayables = 0;
            let balancepayables = 0;
            data.liabilities.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'liability',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitpayables += account.debit;
                    creditpayables += account.credit;
                    balancepayables += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitpayables += account.debit * exchangerate;
                    creditpayables += account.credit * exchangerate;
                    balancepayables += account.balance * exchangerate;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Accounts Payable',
                currencysymbol: accountCurrencySymbol,
                debit: debitpayables,
                credit: creditpayables,
                balance: balancepayables,
                accounttype: 'asset',
                type: 'item',
            });
            totaldebit += debitpayables;
            totalcredit += creditpayables;
            totalbalance += balancepayables;

            trial.push({
                orderid: 3000,
                name: 'Capital',
                type: 'group',
            });
            let debitequity = 0;
            let creditequity = 0;
            let balanceequity = 0;
            data.equity.forEach(equity => {
                trial.push({
                    id: equity.id,
                    orderid: equity.orderid,
                    name: equity.name,
                    currencysymbol: equity.currencysymbol,
                    debit: equity.debit,
                    credit: equity.credit,
                    balance: equity.balance,
                    accounttype: 'equity',
                    type: 'item',
                });
                if (equity.currencyid == accountCurrency) {
                    debitequity += equity.debit;
                    creditequity += equity.credit;
                    balanceequity += equity.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, equity.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitequity += equity.debit * exchangerate;
                    creditequity += equity.credit * exchangerate;;
                    balanceequity += equity.balance * exchangerate;;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Capital',
                currencysymbol: accountCurrencySymbol,
                debit: debitequity,
                credit: creditequity,
                balance: balanceequity,
                accounttype: 'asset',
                type: 'item',
            });
            totaldebit += debitequity;
            totalcredit += creditequity;
            totalbalance += balanceequity;

            trial.push({
                orderid: 4000,
                name: 'Revenue',
                type: 'group',
            });
            let debitrevenue = 0;
            let creditrevenue = 0;
            let balancerevenue = 0;
            data.income.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'income',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitrevenue += account.debit;
                    creditrevenue += account.credit;
                    balancerevenue += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitrevenue += account.debit * exchangerate;
                    creditrevenue += account.credit * exchangerate;
                    balancerevenue += account.balance * exchangerate;
                }
            });

            trial.push({
                id: '',
                orderid: '',
                name: 'Total Revenue',
                currencysymbol: accountCurrencySymbol,
                debit: debitrevenue,
                credit: creditrevenue,
                balance: balancerevenue,
                accounttype: 'asset',
                type: 'item',
            });
            totaldebit += debitrevenue;
            totalcredit += creditrevenue;
            totalbalance += balancerevenue;

            trial.push({
                orderid: 5000,
                name: 'Expenses',
                type: 'group',
            });
            let debitexpenses = 0;
            let creditexpenses = 0;
            let balanceexpenses = 0;
            data.expenses.forEach(account => {
                trial.push({
                    id: account.id,
                    orderid: account.orderid,
                    name: account.name,
                    currencysymbol: account.currencysymbol,
                    debit: account.debit,
                    credit: account.credit,
                    balance: account.balance,
                    accounttype: 'expense',
                    type: 'item',
                });
                if (account.currencyid == accountCurrency) {
                    debitexpenses += account.debit;
                    creditexpenses += account.credit;
                    balanceexpenses += account.balance;
                }
                else {
                    const NearestExchangeRate = findNearestExchangeRate(context.exchangerates, tots, account.currencyid, accountCurrency);
                    const exchangerate = NearestExchangeRate.exchangerate;
                    debitexpenses += account.debit * exchangerate;
                    creditexpenses += account.credit * exchangerate;
                    balanceexpenses += account.balance * exchangerate;
                }
            });
            trial.push({
                id: '',
                orderid: '',
                name: 'Total Expenses',
                currencysymbol: accountCurrencySymbol,
                debit: debitexpenses,
                credit: creditexpenses,
                balance: balanceexpenses,
                accounttype: 'asse6t',
                type: 'item',
            });
            totaldebit += debitexpenses;
            totalcredit += creditexpenses;
            totalbalance += balanceexpenses;

            suspense = totalcredit - totaldebit;
            if (suspense !== 0) {
                trial.push({
                    orderid: '',
                    name: 'Suspense',
                    type: 'group',
                });
                trial.push({
                    id: '',
                    orderid: '',
                    name: 'Suspense account found: some entries are missing or unbalanced. Please fix them before submitting the report.',
                    currencysymbol: accountCurrencySymbol,
                    debit: suspense > 0 ? suspense : 0,
                    credit: suspense < 0 ? Math.abs(suspense) : 0,
                    balance: 0,
                    accounttype: 'asset',
                    type: 'item',
                });
            }
            totaldebit += suspense > 0 ? suspense : 0;
            totalcredit += suspense < 0 ? Math.abs(suspense) : 0;

            trial.push({
                id: '',
                orderid: '',
                name: 'Total',
                currencysymbol: accountCurrencySymbol,
                debit: totaldebit,
                credit: totalcredit,
                balance: totalbalance,
                type: 'item',
            });
            break;

        default:
            break;
    }

    return trial;
}
